// extracted by mini-css-extract-plugin
export default {"buttonContainer":"SimpleModal__buttonContainer___o9DWZ","noWrapText":"SimpleModal__noWrapText___Kk49C"};